<!--<template>
  <div class="card-form">
    <div>
      <page-header
        @reset="reset"
        @add="add"
        @delRows="delRows"
        slot="header"
        @submit="handleSubmit"
        ref="header"
      />
    </div>
    <page-main
      ref="main"
      :table-data="table"
      :loading="loading"
      @submit="reload"
    />
    <js-pagination
      class="mt-2"
      :current-page="page.curPage"
      :page-size="page.pageSize"
      :page-total="page.pageTotal"
      size="sm"
      align="right"
      @change="handlePaginationChange"
    />
  </div>
</template>-->

<template>
  <div class="card-form">
    <page-main
      ref="main"
      :table-data="table"
      :loading="loading"
      @submit="reload"
      :tablePage="page"
    >
      <page-header
        @delRows="delRows"
        @add="add"
        @reset="reset"
        slot="header"
        @submit="handleSubmit"
        ref="header"
      >
      </page-header>
      <pagination
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        size="small"
        align="right"
        slot="pager"
        @change="handlePaginationChange"
      />
    </page-main>
  </div>
</template>

<script>
const initPage = {
  curPage: 1,
  pageSize: 20,
  pageTotal: 0,
};

export default {
  name: "resourceManagement-researchInfoUpdate",
  components: {
    PageHeader: () => import("./components/header"),
    PageMain: () => import("./components/main"),
  },
  data() {
    return {
      table: [],
      loading: false,
      page: {
        ...initPage,
      },
    };
  },
  methods: {
    reset() {
      this.page = {
        ...initPage
      };
    },
    add() {
      this.$refs.main.fromLoad("add", "aa");
    },
    delRows() {
      this.$refs.main.delRows();
    },
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      };
      this.$nextTick(() => {
        this.$refs.header.query();
      });
    },
    // 重载表格数据
    reload() {
      this.$refs.header.onReset();
    },
    // 加载表格数据
    handleSubmit(form) {
      this.loading = true;
      this.$api
        .listResearchInfoApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false;
          this.page.pageTotal = res.body.count;
          this.table = res.body.data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
